import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DocumentsService } from '../service/documents.service';
import * as DocumentsActions from './documents.actions';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class DocumentsEffects {
  private actions$ = inject(Actions);
  private documentsService = inject(DocumentsService);

  getDocuments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentsActions.initDocuments),
      // TO DO: check if the documents are the same, if they are the same, don't call getDocuments()
      //   distinctUntilChanged((prev, curr) =>
      //     prev.id === curr.id && prev.language === curr.language && prev.searchTerm === curr.searchTerm && prev.page === curr.page
      //   // JSON.stringify(prev) === JSON.stringify(curr)
      // ),
      switchMap((action) =>
        this.documentsService
          .getDocuments(
            action.id,
            action.filterValues,
            action.language,
            action.searchTerm,
            action.page,
            action.sort,
            action.documentType,
          )
          .pipe(
            map((_response) => {
              return DocumentsActions.loadDocumentsSuccess({ data: _response });
            }),
            catchError((error) => {
              return of(DocumentsActions.loadDocumentsFailure({ error }));
            }),
          ),
      ),
    ),
  );
}
